import { MarketIssuingCompany } from 'types';
import { CapitolaClient } from './base';

export class MarketIssuingCompanyClient extends CapitolaClient<MarketIssuingCompany> {
  public get resourceName(): string {
    return 'market-issuing-company';
  }
}
